import $axios from "../../../utiles/axios";
import { appendToFormData } from "../../../utiles/apiDataFormat";

export default {
  GET_KLINES_DATA: ({}, payload) => {
    return $axios.post("/market/history", appendToFormData(payload));
  },
};
